export default __webpack_public_path__ + "static/simple-doughnut-f54e4e8afecd11ae3714bf77905bef80.png";